import React from "react";
import { useWebMap, useWatch } from "esri-loader-hooks";
import { loadModules } from "esri-loader";
import { webmapId } from "constants/map";
import layerTitleConfig from "configs/AppLayers.json";

// Layer titles
const TRAILHEAD_TITLE = layerTitleConfig.TRAILHEAD_TITLE;
const TRAIL_DISSOLVED_MIDSCALE_TITLE =
  layerTitleConfig.TRAIL_DISSOLVED_MIDSCALE_TITLE;
const TRAIL_DISSOLVED_STATEWIDE_TITLE =
  layerTitleConfig.TRAIL_DISSOLVED_STATEWIDE_TITLE;
const TRAIL_DISSOLVED_TITLE = layerTitleConfig.TRAIL_DISSOLVED_TITLE;
const TRAIL_DISSOLVED_TITLE_COPY = layerTitleConfig.TRAIL_DISSOLVED_TITLE_COPY;
const FEATURED_ROUTES_TITLE = layerTitleConfig.FEATURED_ROUTES;
const FEATURED_ROUTES_COPY_TITLE = layerTitleConfig.FEATURED_ROUTES_COPY;
const TRAIL_CLOSED_TITLE = layerTitleConfig.TRAIL_CLOSED_TITLE;

export default function MapView({ setPoint }) {
  // takes initial map and view properties as POJOs
  const options = {
    view: {
      center: [-82.8, 40],
      zoom: 5,
    },
  };

  const handleMapReady = async () => {
    const [Graphic] = await loadModules(["esri/Graphic"]);
    initMap(view.map);
    view.on("click", function (evt) {
      // Create a graphic and add the geometry and symbol to it
      var graphic = new Graphic({
        geometry: {
          type: "point",
          latitude: evt.mapPoint.latitude,
          longitude: evt.mapPoint.longitude,
          spatialReference: view.spatialReference,
        },
        symbol: {
          type: "simple-marker", // autocasts as new SimpleFillSymbol
          color: [255, 10, 10],
          outline: {
            // autocasts as new SimpleLineSymbol()
            color: [255, 255, 255],
            width: 2,
          },
        },
      });
      view.graphics.removeAll();
      view.graphics.add(graphic);
      setPoint(graphic.geometry);
    });
  };

  const initMap = async (webmap) => {
    //Turn on POI layers - scaled
    let poiLayer;
    for (let { title, visibilityValue } of Object.values(
      layerTitleConfig.POI_SCALED
    )) {
      //poiLayer = webmap.findLayerById(id);
      poiLayer = webmap.allLayers.find(function (layer) {
        console.log(layer);
        return layer.title === title;
      });
      console.log(poiLayer);
      poiLayer.visible = true;
      poiLayer.popupEnabled = false;
      await poiLayer.load();
      setScaleSymbols(poiLayer, visibilityValue);
    }

    //Turn on dissolved trail, turn off its popup
    const trailDissolvedLayer = webmap.allLayers.find(function (layer) {
      return layer.title === TRAIL_DISSOLVED_TITLE;
    });
    trailDissolvedLayer.visible = true;
    trailDissolvedLayer.popupEnabled = false;
    await trailDissolvedLayer.load();

    const trailClosedLayer = webmap.allLayers.find(function (layer) {
      return layer.title === TRAIL_CLOSED_TITLE;
    });
    console.log(trailClosedLayer);

    trailClosedLayer.visible = true;
    trailClosedLayer.popupEnabled = false;
    await trailClosedLayer.load();
    //Build renderer , white background with 5px , foreground with grey dash line of 2px , using well known color names

    //Turn off dissolved trail copy, turn off its popup
    const trailDissolvedLayerCopy = webmap.allLayers.find(function (layer) {
      return layer.title === TRAIL_DISSOLVED_TITLE_COPY;
    });
    trailDissolvedLayerCopy.visible = true;
    trailDissolvedLayerCopy.popupEnabled = false;
    await trailDissolvedLayerCopy.load();

    //Turn off statewide dissolved trail copy, turn off its popup
    const trailDissolvedStatewideLayerCopy = webmap.allLayers.find(function (
      layer
    ) {
      return layer.title === TRAIL_DISSOLVED_STATEWIDE_TITLE;
    });
    trailDissolvedStatewideLayerCopy.visible = true;
    trailDissolvedStatewideLayerCopy.popupEnabled = false;
    await trailDissolvedStatewideLayerCopy.load();

    //Turn off midscale dissolved trail copy, turn off its popup
    const trailDissolvedMidscaleLayerCopy = webmap.allLayers.find(function (
      layer
    ) {
      return layer.title === TRAIL_DISSOLVED_MIDSCALE_TITLE;
    });
    trailDissolvedMidscaleLayerCopy.visible = true;
    trailDissolvedMidscaleLayerCopy.popupEnabled = false;
    await trailDissolvedMidscaleLayerCopy.load();

    //Turn off dissolved featured routes, turn off its popup
    const featuredRoutesLayer = webmap.allLayers.find(function (layer) {
      return layer.title === FEATURED_ROUTES_TITLE;
    });
    featuredRoutesLayer.visible = true;
    featuredRoutesLayer.popupEnabled = false;
    await featuredRoutesLayer.load();

    //Turn off dissolved featured routes, turn off its popup
    const featuredRoutesCopyLayer = webmap.allLayers.find(function (layer) {
      return layer.title === FEATURED_ROUTES_COPY_TITLE;
    });
    featuredRoutesCopyLayer.visible = true;
    featuredRoutesCopyLayer.popupEnabled = false;
    await featuredRoutesCopyLayer.load();

    //Turn on Trailhead layer
    const trailheadLayer = webmap.allLayers.find(function (layer) {
      return layer.title === TRAILHEAD_TITLE;
    });
    trailheadLayer.visible = true;
    trailheadLayer.popupEnabled = false;
    await trailheadLayer.load();
  };

  const setScaleSymbols = (layer, value) => {
    //create if statement to change stop's values depending on poi layer
    layer.renderer.visualVariables = [
      {
        type: "size",
        valueExpression: "$view.scale",
        stops: [
          {
            size: 23,
            value: value,
          },
          {
            size: 0,
            value: value + 1,
          },
        ],
      },
    ];
  };

  const [ref, view] = useWebMap(webmapId, options);
  useWatch(view, "ready", handleMapReady);

  return <div style={{ height: 300, width: 300 }} ref={ref} />;
}
